<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-26 10:45:26
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-01-04 17:26:20
 * @Description: 维护/查看机构
-->
<template>
  <div class="dept-list component-container">
    <div class="dept-list-head">
      <el-form label-width="80px">
        <div class="dept-form-wrapper">
          <el-form-item label="机构名称:" size="small" style="font-weight: 500">
            <el-input
              class="inputText"
              v-model="dept.name"
              size="small"
              @keyup.enter.native="onSubmit"
              clearable
              placeholder="请输入机构名称"
              @clear="onSubmit"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="deptPower" label="上级机构:" size="small">
            <yl-cascader
              :show-suggestions-all-levels="true"
              :clicked-and-close="true"
              ref="deptCascader"
              class="inputText"
              :props="{ checkStrictly: true }"
              :options="treeDeptData"
              v-model="dept.parentIds"
              @change="handleDeptChange"
              :show-all-levels="false"
              clearable
              filterable
            >
            </yl-cascader>
          </el-form-item>
          <span class="dept-head-opt-btn">
            <common-button type="primary" size="default" image @click="onSubmit"
              >查询</common-button
            >
            <common-button size="default" type="cancel" image @click="reset"
              >重置</common-button
            >
          </span>
        </div>
      </el-form>
    </div>
    <div class="dept-list-body">
      <div class="text">
        <common-button
          type="primary"
          size="default"
          image
          v-show="deptPower"
          @click="createDept"
        >
          新增机构
        </common-button>
        <common-button
          size="default"
          type="primary"
          image
          v-show="superPower"
          @click="batchImport"
        >
          批量导入
        </common-button>
      </div>
      <div class="table-card">
        <detail-table
          v-loading="loading"
          :data="deptData"
          :columns="tableColumns"
          :header-cell-style="headerCellStyle"
          :height="deptPower ? `calc(100vh - 270px)` : `calc(100vh - 222px)`"
          :showBorder="false"
          showOperator
          operatorWidth="150"
        >
          <template #default="{scope}">
            <el-button
              @click="viewDept(scope.row)"
              style="border:0px !important;"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              v-show="deptPower"
              @click="updateDept(scope.row)"
              style="border:0px !important;"
              type="text"
              size="small"
              >修改</el-button
            >
            <el-button
              v-show="deptPower"
              @click="deleteDept(scope.row)"
              style="border:0px !important;"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </detail-table>
      </div>
      <!--机构列表结束-->
      <el-pagination
        style="float: right; padding: 3px 0"
        layout="sizes, prev, pager, next"
        :total="pageCount"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        @current-change="clickChangePage"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="deleteDeptVisible"
      width="30%"
    >
      <span>
        是否删除 <b>{{ deleteDeptInfo.name }}</b> ？
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="deleteDeptVisible = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="sureDeleteDept(deleteDeptInfo)"
          :loading="sureLoading"
          >确 定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      style="text-align: center"
      title="请选择机构数据"
      :visible.sync="drawerVisible"
    >
      <el-upload
        class="upload-demo"
        drag
        action
        multiple
        :http-request="fileUpload"
        :file-list="showFileList"
        :limit="1"
        accept=".xls,.xlsx"
        :before-upload="handleBeforeUpload"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">仅支持xls/xlsx文件</div>
      </el-upload>

      <el-button
        style="margin-top: 20px"
        type="primary"
        size="small"
        @click="saveDeptByFile"
        :loading="fileSaveBtnLoading"
        :disabled="!superPower"
      >
        保存数据
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
//引入formatDatetime方法
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import { mapState } from "vuex";
//获取机构的级联控制器的回显数据
import { getCascaderFullValue } from "@/utils/cascader";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";
import animation from "@/components/loading/animation";
import DetailTable from "@/components/common/DetailTable";

export default {
  name: "List",
  components: {
    animation,
    DetailTable
  },
  data() {
    return {
      loadingDataVisible: false,
      deptPower: false,
      superPower: false,
      fileSaveBtnLoading: false,
      drawerVisible: false,
      loading: true,
      //删除提示框
      deleteDeptVisible: false,
      //确定按钮的状态
      sureLoading: false,
      dept: {
        name: "",
        parentName: "",
        parentIds: [],
        parentId: ""
      },
      //数据页总数
      pageCount: 1,
      //当前页
      currentPage: 1,
      //页数据大小
      pageSize: 10,
      //页数据大小集合
      pageSizeArray: PAGE_SIZE_ARRAY,
      //要删除的机构信息
      deleteDeptInfo: {},
      headerCellStyle: {
        background: "#E5F5F9",
        fontSize: "16px",
        color: "#353739"
      },
      fileList: [],
      showFileList: [],
      deptData: [],
      tableColumns: [
        {
          label: "名称",
          prop: "name",
          align: "left",
          width: "auto",
          sortable: true
        },
        {
          label: "上级机构",
          prop: "parentName",
          align: "left",
          width: "150",
          sortable: true
        },
        {
          label: "创建人",
          prop: "createUserName",
          align: "left",
          width: "150",
          sortable: true
        },
        {
          label: "最后修改人",
          prop: "lastModUserName",
          align: "left",
          width: "150",
          sortable: true
        },
        {
          label: "创建时间",
          prop: "createTm",
          align: "left",
          width: "150",
          sortable: true
        },
        {
          label: "最后修改时间",
          prop: "lastModTm",
          align: "left",
          width: "150",
          sortable: true
        }
      ]
    };
  },

  //挂载
  mounted() {
    this.getAuth();
    this.initDeptListData();
  },

  watch: {
    //页数变化直接缓存
    currentPage() {
      this.$store.state.departmentStore.currentPage = this.currentPage;
    },

    userPower() {
      this.deptPower = this.$store.state.userPowerStore.deptPower;
      this.superPower = this.$store.state.userPowerStore.superPower;
    },

    //列表数据更新
    deptListData(newVal) {
      //关闭加载提示
      this.loading = false;
      this.deptData = newVal;
      this.pageCount = this.$store.state.departmentStore.deptListDataPage;
    },

    treeDeptData(newVal) {
      //设置回显选中的上级机构
      this.dept.parentIds = getCascaderFullValue(newVal, this.dept.parentId);
    }
  },

  computed: mapState({
    userPower: state => state.userPowerStore.userPower,
    unApproveMember: state => state.userPowerStore.unApproveMember,
    deptListData: state => state.departmentStore.deptListData,
    treeDeptData: state => state.departmentStore.treeDeptData
  }),

  methods: {
    //级联选择器选项发生变化
    handleDeptChange(value) {
      // this.$refs.deptCascader.dropDownVisible = false;
      this.dept.parentId = value[value.length - 1];
    },

    // 上传之前判断类型
    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension1 = testMsg === "xls";
      const extension2 = testMsg === "xlsx";
      if (!extension1 && !extension2) {
        this.$message({
          message: "上传文件只能是xls或xlsx格式！",
          type: "warning"
        });
        return false;
      } else {
        return true;
      }
    },

    handleExceed(files, fileList) {
      Message.warning({ message: `只允许上传一个文件`, showClose: true });
    },

    saveDeptByFile() {
      if (this.showFileList.length === 0) {
        Message.error({ message: "请先选择上传的文件", showClose: true });
        return;
      }
      if (this.showFileList.length !== 1) {
        Message.error({ message: "一次只允许上传一个文件", showClose: true });
        return;
      }
      // 使用form表单的数据格式
      const paramsData = new FormData();
      // 将上传文件数组依次添加到参数paramsData中
      this.fileList.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      let jsonData = {
        token: cookie.getCookie("token")
      };
      Message.info("数据导入可能需要几分钟,请耐心等待");
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // 表单数据和文件一起上传,调用后端接口
      this.fileSaveBtnLoading = true;
      http
        .post(
          window.config.api.baseUrl + "/eims-api/department/batchImport",
          paramsData
        )
        .then(value => {
          if (value.data.code === "00000") {
            Message.success("数据导入成功");
          }
        })
        .finally(() => {
          this.fileSaveBtnLoading = false;
        });
    },

    initDeptListData() {
      //机构列表数据
      this.deptData = this.$store.state.departmentStore.deptListData;
      //数据页总数
      this.pageCount = this.$store.state.departmentStore.deptListDataPage;
      this.dept.name = this.$store.state.departmentStore.searchCondition.name;
      this.currentPage = this.$store.state.departmentStore.currentPage;
      this.dept.parentId = this.$store.state.departmentStore.searchCondition.parentId;
      this.loading = false;
      if (this.deptData.length === 0) {
        this.findCurrentAndSub();
      }
      this.$store.dispatch("loadingTreeDeptData");
    },

    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.deptPower = this.$store.state.userPowerStore.deptPower;
        this.superPower = this.$store.state.userPowerStore.superPower;
      });
    },

    fileUpload(file, fileList) {
      //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
      //所以需要定义两个,一个用于显示文件名,一个用于接受文件
      this.showFileList = [];
      this.fileList = [];
      let fileInfo = {
        name: file.file.name
      };
      this.fileList.push(file);
      this.showFileList.push(fileInfo);
    },

    //批量导入医院的数据
    batchImport(file) {
      if (!this.fileSaveBtnLoading) {
        this.showFileList = [];
        this.fileList = [];
      }
      this.drawerVisible = true;
    },

    createDept() {
      this.$router.push("/organization/create");
    },

    onSubmit() {
      this.currentPage = 1;
      this.findCurrentAndSub();
    },

    reset() {
      this.dept.name = "";
      this.dept.parentIds = [];
      this.dept.parentId = "";
      this.$store.state.departmentStore.searchCondition.name = "";
      this.$store.state.departmentStore.searchCondition.parentIds = "";
      //重置时重新加载当前页面数据
      this.currentPage = 1;
      this.findCurrentAndSub();
    },

    //确实删除机构
    sureDeleteDept(dept) {
      this.sureLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          id: dept.id
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/department/delete", obj)
        .then(value => {
          if (value.data.code === "00000") {
            let index = this.deptData.indexOf(dept);
            this.deptData.splice(index, 1);
            Message.success({ message: "机构删除成功", showClose: true });
          }
        })
        .finally(() => {
          this.deleteDeptVisible = false;
          this.sureLoading = false;
        });
    },

    //查看机构的信息
    viewDept(dept) {
      this.$router.push({
        path: "/organization/update",
        query: { deptId: dept.id, flag: "view" }
      });
    },

    //删除机构信息
    deleteDept(dept) {
      this.deleteDeptInfo = dept;
      this.deleteDeptVisible = true;
    },

    //编辑机构信息,需要跳转页面
    updateDept(dept) {
      this.$router.push({
        path: "/organization/update",
        query: { deptId: dept.id, flag: "update" }
      });
    },

    //点击改变页码
    clickChangePage(currentPage) {
      this.currentPage = currentPage;
      this.findCurrentAndSub();
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.findCurrentAndSub();
    },

    //查询当前用户机构及其所有子机构的信息
    findCurrentAndSub() {
      this.loading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          name: this.dept.name,
          parentId: this.dept.parentId
        }
      };
      //使用vuex获取数据
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("findDeptListData", obj);
    }
  }
};
</script>

<style lang="scss" scoped>
.dept-list {
  padding: 10px;
  .dept-list-head {
    margin-bottom: 10px;
    .dept-form-wrapper {
      display: flex;
      flex-wrap: wrap;
      .inputText {
        display: inline-block;
        width: 82%;
      }
    }
  }
  .dept-list-body {
    .text {
      font-size: 14px;
      padding: 3px 0;
    }
    .table-card {
      margin: 10px 0;
    }
  }
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 0;
}
/deep/ .el-form-item--small.el-form-item > * {
  margin-top: 5px;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f3fdff;
}
</style>



// WEBPACK FOOTER //
// src/pages/dept/List.vue